/* eslint-disable no-nested-ternary */
import React, { createContext } from "react"
import PropTypes from "prop-types"
import trackCustomEventTrigger from "utils/trackCustomEventTrigger"

import { StyledA, StyledLink, StyledPlaceholer } from "./BtnLink.styles"

export const LinkContext = createContext(false)

const BtnLink = ({ linkStyles, trackingOptions, ...rest }) => {
  const internal = /^\/(?!\/)/.test(rest.to)
  const content = internal ? (
    <StyledLink
      {...rest}
      linkStyles={linkStyles}
      onClick={() => {
        if (trackingOptions) trackCustomEventTrigger(trackingOptions)
        if (rest && rest.onClick) rest.onClick()
      }}
    />
  ) : rest.to ? (
    <StyledA
      href={rest.to}
      target="_blank"
      rel="noopener noreferrer"
      linkStyles={linkStyles}
      {...rest}
      onClick={() => {
        if (trackingOptions) trackCustomEventTrigger(trackingOptions)
        if (rest && rest.onClick) rest.onClick()
      }}
    >
      {rest.children}
    </StyledA>
  ) : (
    <StyledPlaceholer
      linkStyles={linkStyles}
      {...rest}
      as={rest.onClick ? "button" : "span"}
      type={rest.onClick ? "button" : undefined}
      style={
        rest.onClick
          ? {
              border: 0,
              padding: 0,
              background: "transparent",
              textAlign: "inherit",
              ...rest.style,
            }
          : rest.style
      }
      onClick={() => {
        if (trackingOptions) trackCustomEventTrigger(trackingOptions)
        if (rest && rest.onClick) rest.onClick()
      }}
    >
      {rest.children}
    </StyledPlaceholer>
  )
  return (
    <LinkContext.Provider value={Boolean(rest.to || rest.onClick)}>
      {content}
    </LinkContext.Provider>
  )
}

BtnLink.propTypes = {
  to: PropTypes.string,
  children: PropTypes.any.isRequired,
  linkStyles: PropTypes.any,
  trackingOptions: PropTypes.shape(),
}

BtnLink.defaultProps = {
  linkStyles: "",
  to: null,
  trackingOptions: null,
}

export default BtnLink
